import { Fab } from '@material-ui/core'
import { Add } from '@material-ui/icons'
import styled from 'styled-components'

const ImportJobsButton = styled(Fab)`
  && {
    background-color: #9DC31A;
    box-shadow: none;
    height: 42px;
    width: 42px;
  }

  &&:hover {
    background-color: #9DC31A;
  }
`

const AddIcon = styled(Add)`
  && {
    color: white;
  }
`

const ImportJobsLabel = styled.h1`
  margin: 0;
  font-size: 20px;
  line-height: 20px;
  font-weight: 800;
  color: #9DC31A;
`

const TemplateLink = styled.a`
  font-size: 10.5px;
  line-height: 12px;
  color: #666;
`

const ImportJobsButtonContainer = styled.div`
  display: flex;
  align-items: center;

  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
`

const ImportJobsContainer = styled.div`
  display: flex;
  margin: 20px 0;
`

export {
  ImportJobsContainer,
  ImportJobsButtonContainer,
  ImportJobsButton,
  AddIcon,
  ImportJobsLabel,
  TemplateLink,
}
